import IpubCol from './src/main'

/* istanbul ignore next */
IpubCol.install = function(Vue) {
  Vue.component(IpubCol.name, IpubCol)
}

export default IpubCol
